<template>
    <div style="height:1551px ;  position: relative;">
        <TitleView :titleData="resultData" />
        <!-- 4张图片 -->
        <div class="posture-item-bg">
            <div class="posture-img-bg" :class="isShowMutilView ? 'posture-img-bg-multi' : 'posture-img-bg'"
                ref="bodyOneDivContainer">
                <div class="posture-img-text" style="">冠状位-正</div>

                <canvas class="posture-canvas" :class="isShowMutilView ? 'posture-canvas-multi' : 'posture-canvas'"
                    ref="bodyOneCanvas"></canvas>

                <div class="direction-text">L</div>
            </div>
            <div class="posture-img-bg" :class="isShowMutilView ? 'posture-img-bg-multi' : 'posture-img-bg'"
                ref="bodyThreeDivContainer"  v-show="isShowThird">
                <div class="posture-img-text">冠状位-后</div>
                <canvas class="posture-canvas" :class="isShowMutilView ? 'posture-canvas-multi' : 'posture-canvas'"
                    ref="bodyThreeCanvas"></canvas>
                <div class="direction-text">R</div>
            </div>

            <div class="posture-img-bg"  :class="isShowMutilView ? 'posture-img-bg-multi' : 'posture-img-bg'"
            ref="bodyTwoDivContainer" v-show="isShowSecond">
                <div class="posture-img-text">矢状位-左</div>
                <canvas class="posture-canvas" :class="isShowMutilView ? 'posture-canvas-multi' : 'posture-canvas'"
                ref="bodyTwoCanvas"></canvas>
            </div>
            <div class="posture-img-bg" ref="bodyFourDivContainer" v-show="!isShowMutilView">
                <div class="posture-img-text">矢状位-右</div>
                <canvas class="posture-canvas" ref="bodyFourCanvas"></canvas>
            </div>
        </div>
        
        <div class="axis-box">
            <div class="axis-left-box">
                <div class="axis-box-title">轴位 - 俯视图</div>
                <div class="axis-left-box-content">

                    <div style="width: 130px; margin-top: 24px; margin-left: 15px;  ">
                        <div style="display: flex; align-items: center;">
                            <div style="width: 18px;height: 3px;background: #43B99F;"></div>
                            <div class="axis-alert-title">&nbsp;肩部</div>
                        </div>
                        <div style="display: flex; align-items: center; margin-top: 11px;">
                            <div style="width: 18px;height: 3px;background: #2551A2;"></div>
                            <div class="axis-alert-title">&nbsp;髂嵴</div>
                        </div>
                        <div style="display: flex; align-items: center; margin-top: 11px">
                            <div style="width: 18px;height: 3px;background: #00BAFF;"></div>
                            <div class="axis-alert-title">&nbsp;腿部</div>
                        </div>
                    </div>
                    <!-- <div style="width: 170px;">2</div> -->
                    <div style="width: 350px;height: 160px;  ">
                        <canvas ref="axisOneCanvas"></canvas>

                    </div>
                </div>
            </div>
            <div class="axis-right-box">
                <div class="axis-box-title">冠状位 - 正视图</div>
                <div class="axis-left-box-content">

                    <div style="width: 130px; margin-top: 24px; margin-left: 15px;  ">
                        <div style="display: flex; align-items: center;">
                            <div style="width: 18px;height: 3px;background: #43B99F;"></div>
                            <div class="axis-alert-title">&nbsp;肩部</div>
                        </div>
                        <div style="display: flex; align-items: center; margin-top: 11px;">
                            <div style="width: 18px;height: 3px;background: #2551A2;"></div>
                            <div class="axis-alert-title">&nbsp;髂嵴</div>
                        </div>
                        <div style="display: flex; align-items: center; margin-top: 11px">
                            <div style="width: 18px;height: 3px;background: #00BAFF;"></div>
                            <div class="axis-alert-title">&nbsp;腿部</div>
                        </div>
                    </div>
                    <!-- <div style="width: 170px;">2</div> -->
                    <div style="width: 350px;height: 160px;  ">
                        <canvas ref="axisTwoCanvas"></canvas>

                    </div>
                </div>
            </div>
        </div>
        <!-- 内容 -->
        <div class="posture-prompt-div">
            <div class="posture-value-title-div">

                <div class="posture-value-title-div-left">
                    <div class="posture-value-title-div-left-title">
                        <div class="posture-value-title-label-div">体态评估概览</div>
                        <div class="posture-value-title-label-div" style="font-size: 13px;margin-left: 5px;">Posture
                            Assessment Overview</div>
                    </div>
                    <div style="font-size: 9px;color: #7F7F7F;margin-top: 4px;">*为保障数据精确性，需穿着紧身衣物</div>
                </div>
                <div style="font-size: 9px;color: #7F7F7F;right: 13px;">*为保障数据精确性，需穿着紧身衣物</div>
            </div>
        </div>
        <div class="posture-value-div">
            <div style="height: 26px;margin-top: 9px;display: flex;">
                <div style="width: 112px;height: 100%;"></div>
                <div class="posture-tab-title-div" style="width: 147px;"> 偏移值 </div>
                <div class="posture-tab-title-div" style="width: 147px;"> 与上次对比 </div>
                <div class="posture-tab-title-div" style="width: 228px;" v-if="!this.isHospital"> 评估结论 </div>
                <div class="posture-tab-title-div" style="width: 228px;" v-else> 参考值 </div>
                <div class="posture-tab-title-div" style="width: 392px;"> 风险提示 </div>
            </div>
            <div class="content-tab-div">
                <div>
                    <div class="content-label-div" v-for="item in labels" :key="item">
                        <!-- <div class="content-label-line-div"></div> -->
                        <div class="content-label-text-div">{{ item }}</div>
                    </div>

                </div>
                <div>
                    <div v-for="item in valueDatas" :key="item">
                        <div class="content-value-div">
                            {{ item }}
                        </div>

                    </div>
                </div>
                <div>
                    <div v-for="item in contrastDatas" :key="item">
                        <div class="content-value-div">
                            {{ item }}
                        </div>
                    </div>
                </div>
                <div>
                    <div v-for="item in conclusionDatas" :key="item">
                        <div class="content-value-div" style="width: 228px;" :style="{ color: getcolor(item) }">
                            {{ item }}
                        </div>
                    </div>
                </div>
                <div>
                    <div v-for="(item, index) in riskDatas" :key="item">
                        <div class="content-value-div" style=" color:#333333;width: 392px;">
                            {{ item }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style=" background: #43B99F;height: 1px;margin: 20px 35px 0 35px;"></div>
        <div class="code-div" v-if="resultData.orgId != 13">
            <img :src="qrCodeReport" class="code-img" />
            <div class="code-scode-txt">筛查报告二维码链接</div>

        </div>

        <div style="display: flex; position: absolute;bottom: 0; ">
            <img style=" width: 1100px; height: 18px; " src="../assets/ic-bottom-img.png" />
        </div>
    </div>
</template>
<script>

import TitleView from "@/views/TitleView.vue";
export default {
    props: {
        resultData: {
            type: Object,
            required: true
        },
        imageUrl: {
            type: String,
            required: true,
            default: "https://health-mirror.oss-cn-beijing.aliyuncs.com/actions/1/aaddb3ab64f14365994f8d39e1bc7c6a.jpg"
        },

    },
    data() {
        return {
            physicalResult: {},
            labels: [],
            //偏移量
            valueDatas: [],
            //对比数据
            contrastDatas: [],
            //结论
            conclusionDatas: [],
            //风险
            riskDatas: [],
            colors: {
                normal: "#333333",
                error: "#FF3737"
            },
            qrCodeReport: "",
            authorizationCode: "",
            isHospital: false,
            //是否展示多种布局
            isShowMutilView: true,
            isShowSecond:true,
            isShowThird:true,
            sspType: ""
        }
    },

    components: {
        TitleView,
    },
    computed: {
        
        parseData() {
        console.log('-----parseData')
        try {
        if (!this.resultData || !this.resultData.bodyResult) {
            return null;
        }
        return JSON.parse(this.resultData.bodyResult);
    } catch (error) {
        console.error('Error parsing JSON:', error);
        return null;
    }
  
        },
    },
    mounted() {
       
        this.sspType = this.$route.query.sspType
        this.qrCodeReport = this.resultData.qrCodeReport
        if(this.sspType === "SSP100"){
            this.physicalResult = JSON.parse(this.resultData.physicalResult);
            console.log("-----postureview---SSP100-------", this.physicalResult)
        }else{
            this.physicalResult = JSON.parse(this.resultData.physicalResultThree);
            console.log("-----postureview---not SSP100-------", this.physicalResult)
        }
        this.authorizationCode = this.resultData.authorizationCode
        this.isHospital = this.authorizationCode == 980989 || this.authorizationCode == 980990 || this.authorizationCode == 420277

        const lstHealth = this.resultData.lstHealth;
        const lstHealthLast = this.resultData.lstHealthLast;

        if (Array.isArray(lstHealthLast) && lstHealthLast.length > 0) {
            this.pushData('头前倾', lstHealth.find(item => item.category === 'headForward'), lstHealthLast.find(item => item.category === 'headForward'))
            this.pushData('头侧倾', lstHealth.find(item => item.category === 'headLateral'), lstHealthLast.find(item => item.category === 'headLateral'))
            this.pushData('高低肩', lstHealth.find(item => item.category === 'hlShoulder'), lstHealthLast.find(item => item.category === 'hlShoulder'))
            if (this.isHospital) {
                this.pushData('高度差', lstHealth.find(item => item.category === 'gdc'), lstHealthLast.find(item => item.category === 'gdc'))
                this.pushData('躯干偏移', lstHealth.find(item => item.category === 'bodyTilt'), lstHealthLast.find(item => item.category === 'bodyTilt'))
                this.pushData('圆肩', lstHealth.find(item => item.category === 'shoulderRound'), lstHealthLast.find(item => item.category === 'shoulderRound'))
                this.pushData('脊柱侧弯风险', lstHealth.find(item => item.category === 'spine'), lstHealthLast.find(item => item.category === 'spine'))
                this.pushData('骨盆侧倾', lstHealth.find(item => item.category === 'pelvicTilt'), lstHealthLast.find(item => item.category === 'pelvicTilt'))
                this.pushData('骨盆前倾', lstHealth.find(item => item.category === 'pelvicAnterior'), lstHealthLast.find(item => item.category === 'pelvicAnterior'))
                this.pushData('左膝关节评估', lstHealth.find(item => item.category === 'leftKnee'), lstHealthLast.find(item => item.category === 'leftKnee'))
                this.pushData('右膝关节评估', lstHealth.find(item => item.category === 'rightKnee'), lstHealthLast.find(item => item.category === 'rightKnee'))
            } else {
                this.pushData('左膝关节评估', lstHealth.find(item => item.category === 'leftKnee'), lstHealthLast.find(item => item.category === 'leftKnee'))
                this.pushData('右膝关节评估', lstHealth.find(item => item.category === 'rightKnee'), lstHealthLast.find(item => item.category === 'rightKnee'))
                this.pushData('骨盆侧倾', lstHealth.find(item => item.category === 'pelvicTilt'), lstHealthLast.find(item => item.category === 'pelvicTilt'))
                this.pushData('躯干偏移', lstHealth.find(item => item.category === 'bodyTilt'), lstHealthLast.find(item => item.category === 'bodyTilt'))
                this.pushData('圆肩', lstHealth.find(item => item.category === 'shoulderRound'), lstHealthLast.find(item => item.category === 'shoulderRound'))
                this.pushData('脊柱侧弯风险', lstHealth.find(item => item.category === 'spine'), lstHealthLast.find(item => item.category === 'spine'))
            }
        } else {
            this.pushData('头前倾', lstHealth.find(item => item.category === 'headForward'), lstHealth.find(item => item.category === 'headForward'))
            this.pushData('头侧倾', lstHealth.find(item => item.category === 'headLateral'), lstHealth.find(item => item.category === 'headLateral'))
            this.pushData('高低肩', lstHealth.find(item => item.category === 'hlShoulder'), lstHealth.find(item => item.category === 'hlShoulder'))
            if (this.isHospital) {
                this.pushData('高度差', lstHealth.find(item => item.category === 'gdc'), lstHealth.find(item => item.category === 'gdc'))
                this.pushData('躯干偏移', lstHealth.find(item => item.category === 'bodyTilt'), lstHealth.find(item => item.category === 'bodyTilt'))
                this.pushData('圆肩', lstHealth.find(item => item.category === 'shoulderRound'), lstHealth.find(item => item.category === 'shoulderRound'))
                this.pushData('脊柱侧弯风险', lstHealth.find(item => item.category === 'spine'), lstHealth.find(item => item.category === 'spine'))
                this.pushData('骨盆侧倾', lstHealth.find(item => item.category === 'pelvicTilt'), lstHealth.find(item => item.category === 'pelvicTilt'))
                this.pushData('骨盆前倾', lstHealth.find(item => item.category === 'pelvicAnterior'), lstHealth.find(item => item.category === 'pelvicAnterior'))
                this.pushData('左膝关节评估', lstHealth.find(item => item.category === 'leftKnee'), lstHealth.find(item => item.category === 'leftKnee'))
                this.pushData('右膝关节评估', lstHealth.find(item => item.category === 'rightKnee'), lstHealth.find(item => item.category === 'rightKnee'))
            } else {
                this.pushData('左膝关节评估', lstHealth.find(item => item.category === 'leftKnee'), lstHealth.find(item => item.category === 'leftKnee'))
                this.pushData('右膝关节评估', lstHealth.find(item => item.category === 'rightKnee'), lstHealth.find(item => item.category === 'rightKnee'))
                this.pushData('骨盆侧倾', lstHealth.find(item => item.category === 'pelvicTilt'), lstHealth.find(item => item.category === 'pelvicTilt'))
                this.pushData('躯干偏移', lstHealth.find(item => item.category === 'bodyTilt'), lstHealth.find(item => item.category === 'bodyTilt'))
                this.pushData('圆肩', lstHealth.find(item => item.category === 'shoulderRound'), lstHealth.find(item => item.category === 'shoulderRound'))
                this.pushData('脊柱侧弯风险', lstHealth.find(item => item.category === 'spine'), lstHealth.find(item => item.category === 'spine'))
            }

        }

        //这里判断是否多机位
        if (this.physicalResult.firstImageUrl !== undefined && this.physicalResult.thirdImageUrl !== undefined
            && this.physicalResult.secondImageUrl !== undefined && this.physicalResult.fourthImageUrl !== undefined) {
            this.isShowMutilView = false
        } else {
            this.isShowMutilView = true
        }
        
        if (this.isShowMutilView) {
            // 第一张图片
            const bodyOneDivContainer = this.$refs.bodyOneDivContainer;
            const canvasOneCanvas = this.$refs.bodyOneCanvas;

            const oneImgUrl = this.physicalResult.firstImageUrl
            this.centerImage(canvasOneCanvas, bodyOneDivContainer, oneImgUrl, this.physicalResult.firstData);

          
            if (this.physicalResult.secondImageUrl !== undefined) {
                this.isShowSecond = true;
                const bodyTwoDivContainer = this.$refs.bodyTwoDivContainer;
                const bodyTwoCanvas = this.$refs.bodyTwoCanvas;
                const twoImgUrl = this.physicalResult.secondImageUrl
                this.centerImage(bodyTwoCanvas, bodyTwoDivContainer, twoImgUrl, this.physicalResult.secondData);
            } else {
                this.isShowSecond = false;
            }
           
            if (this.physicalResult.thirdImageUrl !== undefined) {
                //第三张图
                
                const bodyThreeDivContainer = this.$refs.bodyThreeDivContainer;
                const bodyThreeCanvas = this.$refs.bodyThreeCanvas;
                const threeImgUrl = this.physicalResult.thirdImageUrl
                this.centerImage(bodyThreeCanvas, bodyThreeDivContainer, threeImgUrl, this.physicalResult.thirdData);
            } else {
                this.isShowThird = false;
            }
        } else {
            // 第一张图片
            const bodyOneDivContainer = this.$refs.bodyOneDivContainer;
            const canvasOneCanvas = this.$refs.bodyOneCanvas;

            const oneImgUrl = this.physicalResult.firstImageUrl
            this.centerImage(canvasOneCanvas, bodyOneDivContainer, oneImgUrl, this.physicalResult.firstData);

            //第三张图
            const bodyThreeDivContainer = this.$refs.bodyThreeDivContainer;
            const bodyThreeCanvas = this.$refs.bodyThreeCanvas;

            const threeImgUrl = this.physicalResult.thirdImageUrl
            this.centerImage(bodyThreeCanvas, bodyThreeDivContainer, threeImgUrl, this.physicalResult.thirdData);

            // 第二张图片
            const bodyTwoDivContainer = this.$refs.bodyTwoDivContainer;
            const bodyTwoCanvas = this.$refs.bodyTwoCanvas;
            const twoImgUrl = this.physicalResult.secondImageUrl
            this.centerImage(bodyTwoCanvas, bodyTwoDivContainer, twoImgUrl, this.physicalResult.secondData);

            //第四张图
            const bodyFourDivContainer = this.$refs.bodyFourDivContainer;
            const bodyFourCanvas = this.$refs.bodyFourCanvas;
            const fourImgUrl = this.physicalResult.fourthImageUrl
            this.centerImage(bodyFourCanvas, bodyFourDivContainer, fourImgUrl, this.physicalResult.fourthData);
        }


        this.setAxisCanvas()
    },
    methods: {

        pushData(name, physical, lsValue) {
            if (physical) {

                try {
                    if (Number(physical.value) > Number(lsValue.value)) {
                        this.contrastDatas.push('↑' + Math.abs(Number(physical.value) - Number(lsValue.value)).toFixed(1))
                    } else if (Number(physical.value) < Number(lsValue.value)) {
                        this.contrastDatas.push('↓' + Math.abs(Number(physical.value) - Number(lsValue.value)).toFixed(1))
                    } else {
                        this.contrastDatas.push('')
                    }
                } catch (error) {

                }

                switch (name) {
                    case '头前倾':
                        this.labels.push(name)
                        this.valueDatas.push(Number(physical.value).toFixed(1) + physical.unit)
                        if (this.isHospital) {
                            this.conclusionDatas.push('<4°')
                        } else {
                            this.conclusionDatas.push(physical.des)
                        }

                        if (physical.result == 'NORMAL') {
                            this.riskDatas.push('- -')
                        } else {
                            this.riskDatas.push('会对头近段肌肉造成额外负荷。长期头前倾容易造成颈椎生理曲度变直、中下斜方肌无力、菱形肌无力、肩胛提肌、胸锁乳突肌、斜角肌和胸小肌等肌肉紧张')
                        }

                        break;
                    case '头侧倾':
                        this.labels.push(name)
                        this.valueDatas.push(physical.value + physical.unit + '（→ ' + physical.type + '）')
                        if (this.isHospital) {
                            this.conclusionDatas.push('<2.5°')
                        } else {
                            this.conclusionDatas.push(physical.des)
                        }

                        if (physical.result == 'NORMAL') {
                            this.riskDatas.push('- -')
                        } else {
                            this.riskDatas.push('双侧胸锁乳突肌拉力不平衡，易发生高低肩、脊柱侧弯等')
                        }

                        break;
                    case '圆肩':
                        this.labels.push(name)
                        this.valueDatas.push(physical.value)
                        if (this.isHospital) {
                            this.conclusionDatas.push('阴性')
                        } else {
                            this.conclusionDatas.push(physical.des)
                        }
                        if (physical.result == 'NORMAL') {
                            this.riskDatas.push('- -')
                        } else {
                            this.riskDatas.push('圆肩使胸廓容积变小、膈肌活动受限，影响呼吸、心血管及消化吸收功能，出现胸闷、头晕、气短等症状')
                        }

                        break;
                    case '高低肩':
                        if (physical.value > 0) {
                            this.valueDatas.push(Math.abs(physical.value) + physical.unit + '（→  R）')
                        } else if (physical.value < 0) {
                            this.valueDatas.push(Math.abs(physical.value) + physical.unit + '（→  L）')
                        } else {
                            this.valueDatas.push(Math.abs(physical.value) + physical.unit)
                        }
                        if (this.isHospital) {
                            this.conclusionDatas.push('<2°')
                        } else {
                            this.conclusionDatas.push(physical.des)
                        }
                        if (this.isHospital) {
                            this.labels.push('高低肩角度')
                        } else {
                            this.labels.push(name)
                        }
                        if (physical.result == 'NORMAL') {
                            this.riskDatas.push('- -')
                        } else {
                            this.riskDatas.push('高低肩可引发颈肩部的慢性疼痛，常伴随脊柱侧弯、骨盆位移、长短腿等情况出现')
                        }

                        break;
                    case '高度差':
                        name = '高低肩'
                        if (physical.value > 0) {
                            this.valueDatas.push(Math.abs(physical.value).toFixed(1) + physical.unit + '（→  L）')
                        } else if (physical.value < 0) {
                            this.valueDatas.push(Math.abs(physical.value).toFixed(1) + physical.unit + '（→  R）')
                        } else {
                            this.valueDatas.push(Math.abs(physical.value) + physical.unit)
                        }
                        if (this.isHospital) {
                            this.conclusionDatas.push('<1cm')
                        } else {
                            this.conclusionDatas.push(physical.des)
                        }
                        if (this.isHospital) {
                            this.labels.push('肩膀高度差')

                        } else {
                            this.labels.push(name)
                        }
                        if (physical.result == 'NORMAL') {
                            this.riskDatas.push('- -')
                        } else {
                            this.riskDatas.push('高低肩可引发颈肩部的慢性疼痛，常伴随脊柱侧弯、骨盆位移、长短腿等情况出现')
                        }
                        break;
                    case '左膝关节评估':
                        this.labels.push(name)
                        if (physical.value == 0) {
                            this.valueDatas.push(Number(physical.value).toFixed(1) + physical.unit)
                        } else {
                            this.valueDatas.push(physical.type + " " + Number(physical.value).toFixed(1) + physical.unit)
                        }
                        if (this.isHospital) {
                            this.conclusionDatas.push('<2.5°')
                        } else {
                            if (physical.result == 'NORMAL') {
                                this.conclusionDatas.push('正常')
                            } else {
                                this.conclusionDatas.push('膝' + physical.type + physical.des)
                            }
                        }
                        if (physical.result == 'NORMAL') {
                            this.riskDatas.push('- -')
                        } else {
                            if (physical.type == '内翻') {
                                this.riskDatas.push('造成下肢力线改变，O型腿形态、关节软骨磨损异常，长期膝内翻可造成膝关节外形改变，造成前交叉韧带磨损等')
                            } else if (physical.type == '外翻') {
                                this.riskDatas.push('膝关节内侧副韧带张力增加、稳定性降低、增加内侧副韧带可能性。半月板外侧易压缩磨损受伤。体态问题髋关节过度内收和内旋、胫骨外旋等')
                            }
                        }
                        break;
                    case '右膝关节评估':
                        this.labels.push(name)
                        if (physical.value == 0) {
                            this.valueDatas.push(Number(physical.value).toFixed(1) + physical.unit)
                        } else {
                            this.valueDatas.push(physical.type + " " + Number(physical.value).toFixed(1) + physical.unit)
                        }
                        if (this.isHospital) {
                            this.conclusionDatas.push('<2.5°')
                        } else {
                            if (physical.result == 'NORMAL') {
                                this.conclusionDatas.push('正常')
                            } else {
                                this.conclusionDatas.push('膝' + physical.type + physical.des)
                            }
                        }
                        if (physical.result == 'NORMAL') {
                            this.riskDatas.push('- -')
                        } else {
                            if (physical.type == '内翻') {
                                this.riskDatas.push('造成下肢力线改变，O型腿形态、关节软骨磨损异常，长期膝内翻可造成膝关节外形改变，造成前交叉韧带磨损等')
                            } else if (physical.type == '外翻') {
                                this.riskDatas.push('膝关节内侧副韧带张力增加、稳定性降低、增加内侧副韧带可能性。半月板外侧易压缩磨损受伤。体态问题髋关节过度内收和内旋、胫骨外旋等')
                            }
                        }
                        break;
                    case '骨盆侧倾':
                        this.labels.push(name)
                        if (physical.value > 0) {
                            this.valueDatas.push(Math.abs(physical.value) + physical.unit + '（→  R）')
                        } else if (physical.value < 0) {
                            this.valueDatas.push(Math.abs(physical.value) + physical.unit + '（→  L）')
                        } else {
                            this.valueDatas.push(Math.abs(physical.value) + physical.unit)
                        }
                        if (this.isHospital) {
                            this.conclusionDatas.push('<2.5°')
                        } else {
                            this.conclusionDatas.push(physical.des)
                        }
                        if (physical.result == 'NORMAL') {
                            this.riskDatas.push('- -')
                        } else {
                            this.riskDatas.push('骨盆前后移容易引起腰肌劳损、脏器下垂、盆底肌无力等')
                        }
                        break;
                    case '骨盆前倾':
                        this.labels.push(name)
                        this.valueDatas.push(physical.value + physical.unit)
                        if (this.isHospital) {
                            this.conclusionDatas.push('<10°')
                        } else {
                            this.conclusionDatas.push(physical.des)
                        }

                        if (physical.result == 'NORMAL') {
                            this.riskDatas.push('- -')
                        } else {
                            this.riskDatas.push('骨盆前倾可能导致身形不美观、出现腹部凸起、下肢肥胖、骨盆变形等')
                        }
                        break;
                    case '躯干偏移':
                        this.labels.push(name)
                        if (physical.value < 0) {
                            this.valueDatas.push(Math.abs(physical.value) + physical.unit + '（→  R）')
                        } else if (physical.value > 0) {
                            this.valueDatas.push(Math.abs(physical.value) + physical.unit + '（→  L）')
                        } else {
                            this.valueDatas.push(Math.abs(physical.value) + physical.unit)
                        }
                        if (this.isHospital) {
                            this.conclusionDatas.push('<1°')
                        } else {
                            this.conclusionDatas.push(physical.des)
                        }

                        if (physical.result == 'NORMAL') {
                            this.riskDatas.push('- -')
                        } else {
                            this.riskDatas.push('躯干偏移会导致踝关节、膝关节受力增大，引起腰背疼痛，严重的可能出现骨盆倾斜或长短腿')
                        }
                        break;
                    case '脊柱侧弯风险':
                        this.labels.push(name)
                        this.valueDatas.push(physical.value)

                        if (this.isHospital) {
                            this.conclusionDatas.push('阴性')
                        } else {
                            this.conclusionDatas.push(physical.des)
                        }
                        if (physical.result == 'NORMAL') {
                            this.riskDatas.push('- -')
                        } else {
                            this.riskDatas.push('造成脊柱发育畸形、心肺功能受损、胸廓畸形、椎间盘突出、神经系统发育异常、体态异常等问题')
                        }
                        break;
                }

                // if (physical.result == "NORMAL") {
                //     this.riskDatas.push('- -')
                // } else {

                // }


            }
        },

        //缩放裁剪图片
        centerImage(canvas, container, imgUrl, porstureData) {
            // if(!canvas){
            //     return
            // }
            const img = new Image();
            img.crossOrigin = 'Anonymous';
            img.src = imgUrl; // 替换为实际图片的URL
            img.onload = () => {
                const ctx = canvas.getContext('2d');
                if (this.isShowMutilView) {
                    //设置canvas的宽高
                    canvas.width = 513
                    canvas.height = 310
                    //canvas宽高
                    const maxWidth = canvas.width;
                    const maxHeight = canvas.height;
                    //缩放比例
                    const scale = canvas.height / img.height
                    //图片截取前的宽度
                    const imgWidth = canvas.height * img.width / img.height
                    const rote = (imgWidth - maxWidth) / 2

                    const newWidth = img.height * maxWidth / maxHeight;

                    const sourceX = (img.width - newWidth) / 2;

                    console.log(imgWidth + "  " + rote);
                    // 绘制裁剪后的图片到canvas上
                    // img: 要绘制到画布上的图像，
                    // sx, sy: 可选。开始剪切的 x, y 坐标位置。
                    // sWidth, sHeight: 可选。被剪切图像的宽度和高度。
                    // dx, dy: 将图像绘制到画布上的 x, y 坐标位置。
                    // dWidth, dHeight: 可选。在画布上绘制图像的宽度和高度。
                    ctx.drawImage(img, sourceX, 0, newWidth, img.height, 0, 0, maxWidth, maxHeight);
                    switch (canvas) {

                        case this.$refs.bodyOneCanvas:
                            //第一张图
                            this.switchOneImg(scale, rote, porstureData, container);
                            return
                        case this.$refs.bodyThreeCanvas:
                            this.switchThreeImg(scale, rote, porstureData, container);
                            return

                        // case this.$refs.bodyTwoCanvas:
                        //     this.switchTwoImg(scale, rote, porstureData, container);
                        //     return

                        // case this.$refs.bodyFourCanvas:
                        //     this.switchFourImg(scale, rote, porstureData, container);
                        //     return

                    }
                } else {
                    //设置canvas的宽高
                    canvas.width = 254
                    canvas.height = 310
                    //canvas宽高
                    const maxWidth = canvas.width;
                    const maxHeight = canvas.height;
                    //缩放比例
                    const scale = canvas.height / img.height
                    //图片截取前的宽度
                    const imgWidth = canvas.height * img.width / img.height
                    const rote = (imgWidth - maxWidth) / 2

                    const newWidth = img.height * maxWidth / maxHeight;

                    const sourceX = (img.width - newWidth) / 2;

                    console.log(imgWidth + "  " + rote);
                    // 绘制裁剪后的图片到canvas上
                    // img: 要绘制到画布上的图像，
                    // sx, sy: 可选。开始剪切的 x, y 坐标位置。
                    // sWidth, sHeight: 可选。被剪切图像的宽度和高度。
                    // dx, dy: 将图像绘制到画布上的 x, y 坐标位置。
                    // dWidth, dHeight: 可选。在画布上绘制图像的宽度和高度。
                    ctx.drawImage(img, sourceX, 0, newWidth, img.height, 0, 0, maxWidth, maxHeight);
                    switch (canvas) {

                        case this.$refs.bodyOneCanvas:
                            //第一张图
                            this.switchOneImg(scale, rote, porstureData, container);
                            return
                        case this.$refs.bodyThreeCanvas:
                            this.switchThreeImg(scale, rote, porstureData, container);
                            return

                        case this.$refs.bodyTwoCanvas:
                            this.switchTwoImg(scale, rote, porstureData, container);
                            return

                        case this.$refs.bodyFourCanvas:
                            this.switchFourImg(scale, rote, porstureData, container);
                            return

                    }
                }


            }
        },

        getCanvas(canvasContainer) {
            if (!canvasContainer) {
                console.error('canvasContainer is required');
                return;
            }
            const canvas = document.createElement('canvas');
            canvas.width = canvasContainer.clientWidth;
            canvas.height = canvasContainer.clientHeight;
            canvas.style.position = 'absolute';
            canvas.style.top = '0';
            canvas.style.left = '0';
            canvasContainer.appendChild(canvas);
            const ctx = canvas.getContext('2d');
            return ctx
        },

        //绘画圆点
        drawPoint(startX, startY, ctx) {
            // 画实心圆点
            ctx.beginPath();
            ctx.arc(startX, startY, 2, 0, 2 * Math.PI);
            ctx.fillStyle = '#00BD8A'; // 设置圆点颜色
            ctx.fill();
        },
        //划线
        drawLine(ctx, scale, rote, pointF, pointS) {
            const startX = pointF.x * scale - rote
            const startY = scale * pointF.y
            const endX = pointS.x * scale - rote
            const endY = scale * pointS.y
            ctx.beginPath();
            ctx.moveTo(startX, startY); // 起点坐标
            ctx.lineTo(endX, endY); // 终点坐标
            ctx.strokeStyle = '#00BD8A'; // 线条颜色
            ctx.lineWidth = 1; // 线条宽度
            ctx.lineWidth = 1; // 线条宽度            }
            ctx.stroke(); // 绘制线条
        },

        //4张图切换
        switchOneImg(scale, rote, porstureData, container,) {
            const canvas = this.getCanvas(container)
            if (!canvas) {
                return
            }
            this.drawLine(canvas, scale, rote, porstureData.left_shoulder, porstureData.right_shoulder)

            this.drawLine(canvas, scale, rote, porstureData.left_hip, porstureData.left_knee)
            this.drawLine(canvas, scale, rote, porstureData.right_hip, porstureData.right_knee)
            this.drawLine(canvas, scale, rote, porstureData.left_knee, porstureData.left_ankle)
            this.drawLine(canvas, scale, rote, porstureData.right_knee, porstureData.right_ankle)

            this.drawPoint(porstureData.nose.x * scale - rote, scale * porstureData.nose.y, canvas)
            this.drawPoint(porstureData.left_ear.x * scale - rote, scale * porstureData.left_ear.y, canvas)
            this.drawPoint(porstureData.right_ear.x * scale - rote, scale * porstureData.right_ear.y, canvas)
            this.drawPoint(porstureData.left_shoulder.x * scale - rote, scale * porstureData.left_shoulder.y, canvas)
            this.drawPoint(porstureData.right_shoulder.x * scale - rote, scale * porstureData.right_shoulder.y, canvas)
            this.drawPoint(porstureData.left_elbow.x * scale - rote, scale * porstureData.left_elbow.y, canvas)
            this.drawPoint(porstureData.right_elbow.x * scale - rote, scale * porstureData.right_elbow.y, canvas)
            this.drawPoint(porstureData.left_wrist.x * scale - rote, scale * porstureData.left_wrist.y, canvas)
            this.drawPoint(porstureData.right_wrist.x * scale - rote, scale * porstureData.right_wrist.y, canvas)
            this.drawPoint(porstureData.left_hip.x * scale - rote, scale * porstureData.left_hip.y, canvas)
            this.drawPoint(porstureData.right_hip.x * scale - rote, scale * porstureData.right_hip.y, canvas)
            this.drawPoint(porstureData.left_knee.x * scale - rote, scale * porstureData.left_knee.y, canvas)
            this.drawPoint(porstureData.right_knee.x * scale - rote, scale * porstureData.right_knee.y, canvas)
            this.drawPoint(porstureData.left_ankle.x * scale - rote, scale * porstureData.left_ankle.y, canvas)
            this.drawPoint(porstureData.right_ankle.x * scale - rote, scale * porstureData.right_ankle.y, canvas)

        },

        switchTwoImg(scale, rote, porstureData, container) {
            const canvas = this.getCanvas(container)
            if (!canvas) {
                return
            }

            this.drawLine(canvas, scale, rote, porstureData.left_hip, porstureData.left_knee)
            this.drawLine(canvas, scale, rote, porstureData.left_knee, porstureData.left_ankle)

            this.drawPoint(porstureData.nose.x * scale - rote, scale * porstureData.nose.y, canvas)
            this.drawPoint(porstureData.right_ear.x * scale - rote, scale * porstureData.right_ear.y, canvas)
            this.drawPoint(porstureData.left_shoulder.x * scale - rote, scale * porstureData.left_shoulder.y, canvas)
            // this.drawPoint(porstureData.right_shoulder.x * scale - rote, scale * porstureData.right_shoulder.y, canvas)
            this.drawPoint(porstureData.left_elbow.x * scale - rote, scale * porstureData.left_elbow.y, canvas)
            // this.drawPoint(porstureData.right_elbow.x * scale - rote, scale * porstureData.right_elbow.y, canvas)
            this.drawPoint(porstureData.left_wrist.x * scale - rote, scale * porstureData.left_wrist.y, canvas)
            // this.drawPoint(porstureData.right_wrist.x * scale - rote, scale * porstureData.right_wrist.y, canvas)
            this.drawPoint(porstureData.left_hip.x * scale - rote, scale * porstureData.left_hip.y, canvas)
            // this.drawPoint(porstureData.right_hip.x * scale - rote, scale * porstureData.right_hip.y, canvas)
            this.drawPoint(porstureData.left_knee.x * scale - rote, scale * porstureData.left_knee.y, canvas)
            // this.drawPoint(porstureData.right_knee.x * scale - rote, scale * porstureData.right_knee.y, canvas)
            this.drawPoint(porstureData.left_ankle.x * scale - rote, scale * porstureData.left_ankle.y, canvas)
            // this.drawPoint(porstureData.right_ankle.x * scale - rote, scale * porstureData.right_ankle.y, canvas)

        },

        switchThreeImg(scale, rote, porstureData, container) {
            const canvas = this.getCanvas(container)
            if (!canvas) {
                return
            }
            //_LEFT_KNEE
            this.drawLine(canvas, scale, rote, porstureData.left_shoulder, porstureData.right_shoulder)
            this.drawLine(canvas, scale, rote, porstureData.left_hip, porstureData.left_knee)
            this.drawLine(canvas, scale, rote, porstureData.right_hip, porstureData.right_knee)
            this.drawLine(canvas, scale, rote, porstureData.left_knee, porstureData.left_ankle)
            this.drawLine(canvas, scale, rote, porstureData.right_knee, porstureData.right_ankle)

            this.drawPoint(porstureData.left_shoulder.x * scale - rote, scale * porstureData.left_shoulder.y, canvas)
            this.drawPoint(porstureData.right_shoulder.x * scale - rote, scale * porstureData.right_shoulder.y, canvas)
            this.drawPoint(porstureData.left_elbow.x * scale - rote, scale * porstureData.left_elbow.y, canvas)
            this.drawPoint(porstureData.right_elbow.x * scale - rote, scale * porstureData.right_elbow.y, canvas)
            this.drawPoint(porstureData.left_wrist.x * scale - rote, scale * porstureData.left_wrist.y, canvas)
            this.drawPoint(porstureData.right_wrist.x * scale - rote, scale * porstureData.right_wrist.y, canvas)
            this.drawPoint(porstureData.left_hip.x * scale - rote, scale * porstureData.left_hip.y, canvas)
            this.drawPoint(porstureData.right_hip.x * scale - rote, scale * porstureData.right_hip.y, canvas)
            this.drawPoint(porstureData.left_knee.x * scale - rote, scale * porstureData.left_knee.y, canvas)
            this.drawPoint(porstureData.right_knee.x * scale - rote, scale * porstureData.right_knee.y, canvas)
            this.drawPoint(porstureData.left_ankle.x * scale - rote, scale * porstureData.left_ankle.y, canvas)
            this.drawPoint(porstureData.right_ankle.x * scale - rote, scale * porstureData.right_ankle.y, canvas)
        },

        switchFourImg(scale, rote, porstureData, container) {
            const canvas = this.getCanvas(container)
            if (!canvas) {
                return
            }

            this.drawLine(canvas, scale, rote, porstureData.right_hip, porstureData.right_knee)
            this.drawLine(canvas, scale, rote, porstureData.right_knee, porstureData.right_ankle)

            this.drawPoint(porstureData.nose.x * scale - rote, scale * porstureData.nose.y, canvas)
            this.drawPoint(porstureData.right_ear.x * scale - rote, scale * porstureData.right_ear.y, canvas)
            // this.drawPoint(porstureData.left_shoulder.x * scale - rote, scale * porstureData.left_shoulder.y, canvas)
            this.drawPoint(porstureData.right_shoulder.x * scale - rote, scale * porstureData.right_shoulder.y, canvas)
            // this.drawPoint(porstureData.left_elbow.x * scale - rote, scale * porstureData.left_elbow.y, canvas)
            this.drawPoint(porstureData.right_elbow.x * scale - rote, scale * porstureData.right_elbow.y, canvas)
            // this.drawPoint(porstureData.left_wrist.x * scale - rote, scale * porstureData.left_wrist.y, canvas)
            this.drawPoint(porstureData.right_wrist.x * scale - rote, scale * porstureData.right_wrist.y, canvas)
            // this.drawPoint(porstureData.left_hip.x * scale - rote, scale * porstureData.left_hip.y, canvas)
            this.drawPoint(porstureData.right_hip.x * scale - rote, scale * porstureData.right_hip.y, canvas)
            // this.drawPoint(porstureData.left_knee.x * scale - rote, scale * porstureData.left_knee.y, canvas)
            this.drawPoint(porstureData.right_knee.x * scale - rote, scale * porstureData.right_knee.y, canvas)
            // this.drawPoint(porstureData.left_ankle.x * scale - rote, scale * porstureData.left_ankle.y, canvas)
            this.drawPoint(porstureData.right_ankle.x * scale - rote, scale * porstureData.right_ankle.y, canvas)
        },
        // 轴位绘制
        axisLine(canvas, startX, startY, endX, endY, angle, textAngle, length, colorBg) {
            const ctx = canvas.getContext('2d');

            // 设置抗锯齿属性
            ctx.imageSmoothingEnabled = true;
            // 绘制虚线
            const drawDashedLine = (x1, y1, x2, y2, dashLength = 5) => {
                ctx.setLineDash([dashLength, dashLength]);
                ctx.beginPath();
                ctx.moveTo(x1, y1);
                ctx.lineTo(x2, y2);
                ctx.lineWidth = 1;
                ctx.strokeStyle = colorBg; // 线条颜色
                ctx.stroke();
            };

            // 绘制直线
            const drawLine = (x1, y1, angle, length) => {
                const x2 = x1 + length * Math.cos(angle * Math.PI / 180);
                const y2 = y1 + length * Math.sin(angle * Math.PI / 180);
                ctx.setLineDash([]); // 清除虚线设置
                ctx.beginPath();
                ctx.moveTo(x1, y1);
                ctx.lineTo(x2, y2);
                ctx.strokeStyle = colorBg; // 线条颜色
                ctx.lineWidth = 2;
                ctx.stroke();
            };
            //绘画文字
            const drawText = (text, startX, startY) => {
                ctx.font = '10px Arial';
                ctx.fillStyle = colorBg;
                ctx.fillText(text, 10 + startX, startY + 6);
            }

            // 绘制虚线示例
            drawDashedLine(startX, startY, endX, endY);

            // 根据传入的参数绘制直线
            drawLine(startX, startY, angle, length);
            
            //绘制文字
            if(textAngle>300){
                textAngle = 360 -textAngle
            } 
            if (canvas == this.$refs.axisOneCanvas) {
                drawText("旋转" + Math.abs(textAngle) + "°", endX, endY)
            }
            else {
                drawText("倾斜" + Math.abs(textAngle) + "°", endX, endY)
            }

        },

        //划线
        drawAxisline(canvas, startX, startY, angle, length, colorBg) {
            const ctx = canvas.getContext('2d');
            // 绘制直线
            // 根据角度和长度计算终点坐标
            const calculateEndPoint = (x1, y1, angle, length) => {
                const x2 = x1 + length * Math.cos(angle * Math.PI / 180);
                const y2 = y1 + length * Math.sin(angle * Math.PI / 180);
                return { x2, y2 };
            };

            // 绘制直线
            const drawLine = (x1, y1, x2, y2) => {
                ctx.setLineDash([]); // 清除虚线设置
                ctx.beginPath();
                ctx.moveTo(x1, y1);
                ctx.lineTo(x2, y2);
                ctx.strokeStyle = colorBg; // 线条颜色
                ctx.lineWidth = 2;
                ctx.stroke();
            };

            // 计算终点坐标
            const { x2, y2 } = calculateEndPoint(startX, startY, angle, length);

            // 绘制直线
            drawLine(startX, startY, x2, y2);
        },


        //绘画文字
        drawBottomTitleText(canvas, text, startX, startY) {
            const ctx = canvas.getContext('2d');
            ctx.font = '10px Arial';
            ctx.fillStyle = '#7F7F7F';
            ctx.fillText(text, startX, startY);

        },
        setAxisCanvas() {
            //冠状位--正视图
            const canvas = this.$refs.axisTwoCanvas;
            //肩部（按照图片来说图片左边是右肩  右边是左肩  虚线是以右肩为基础）
            //如果 右肩Y<左肩Y  实线向下 反之向上
            let shoulderLastPoint = { x: this.physicalResult.firstData.left_shoulder.x, y: this.physicalResult.firstData.right_shoulder.y }
            const shoulderAngle = this.getAngle(this.physicalResult.firstData.left_shoulder, this.physicalResult.firstData.right_shoulder, shoulderLastPoint)
            //向下
            if (this.physicalResult.firstData.right_shoulder.y < this.physicalResult.firstData.left_shoulder.y) {
                this.axisLine(canvas, 150, 20, 250, 20, shoulderAngle, shoulderAngle, 95, '#43B99F',)
                this.drawAxisline(canvas, 10, 20, shoulderAngle, 95, '#43B99F')
            } else {
                this.axisLine(canvas, 150, 20, 250, 20, (360 - shoulderAngle), shoulderAngle, 95, '#43B99F')
                this.drawAxisline(canvas, 10, 20, (360 - shoulderAngle), 95, '#43B99F')
            }

            let hipLastPoint = { x: this.physicalResult.firstData.left_hip.x, y: this.physicalResult.firstData.right_hip.y }
            const hipAngle = this.getAngle(this.physicalResult.firstData.left_hip, this.physicalResult.firstData.right_hip, hipLastPoint)
            //向下
            if (this.physicalResult.firstData.right_hip.y < this.physicalResult.firstData.left_hip.y) {
                this.axisLine(canvas, 150, 50, 250, 50, hipAngle, hipAngle, 95, '#2551A2')
                this.drawAxisline(canvas, 10, 50, hipAngle, 95, '#2551A2')
            } else {
                this.axisLine(canvas, 150, 50, 250, 50, (360 - hipAngle), hipAngle, 95, '#2551A2')
                this.drawAxisline(canvas, 10, 50, (360 - hipAngle), 95, '#2551A2')
            }

            let kneeLastPoint = { x: this.physicalResult.firstData.left_knee.x, y: this.physicalResult.firstData.right_knee.y }
            const kneeAngle = this.getAngle(this.physicalResult.firstData.left_knee, this.physicalResult.firstData.right_knee, kneeLastPoint)
            //向下
            if (this.physicalResult.firstData.right_knee.y < this.physicalResult.firstData.left_knee.y) {
                this.axisLine(canvas, 150, 80, 250, 80, kneeAngle, kneeAngle, 95, '#00BAFF')
                this.drawAxisline(canvas, 10, 80, kneeAngle, 95, '#00BAFF')
            } else {
                this.axisLine(canvas, 150, 80, 250, 80, (360 - kneeAngle), kneeAngle, 95, '#00BAFF')
                this.drawAxisline(canvas, 10, 80, (360 - kneeAngle), 95, '#00BAFF')
            }
            this.drawBottomTitleText(canvas, "冠状位倾斜角度", 170, 115)
            this.drawBottomTitleText(canvas, "正视图", 40, 115)

            //轴位 - 俯视图
            const twoCanvas = this.$refs.axisOneCanvas;
            if (this.physicalResult.thirdData) {
                const hipAngle1 = this.getDeepAngle(this.physicalResult.thirdData.left_hip, this.physicalResult.thirdData.right_hip)

                if (this.physicalResult.thirdData.right_hip.sz < this.physicalResult.thirdData.left_hip.sz) {
                    this.axisLine(twoCanvas, 150, 50, 250, 50, (360 - 0), 0, 95, '#2551A2')
                    this.drawAxisline(twoCanvas, 10, 50, (360 - 0), 95, '#2551A2')
                } else {
                    this.axisLine(twoCanvas, 150, 50, 250, 50, 0, 0, 95, '#2551A2')
                    this.drawAxisline(twoCanvas, 10, 50, 0, 95, '#2551A2')
                }

                let shoulderAngle1 = this.getDeepAngle(this.physicalResult.thirdData.left_shoulder, this.physicalResult.thirdData.right_shoulder)

                shoulderAngle1 = shoulderAngle1 - hipAngle1
                if (this.physicalResult.thirdData.right_shoulder.sz < this.physicalResult.firstData.left_shoulder.sz) {
                    this.axisLine(twoCanvas, 150, 20, 250, 20, (360 - shoulderAngle1), shoulderAngle1, 95, '#43B99F')
                    this.drawAxisline(twoCanvas, 10, 40, (360 - shoulderAngle1), 95, '#43B99F')
                } else {
                    this.axisLine(twoCanvas, 150, 20, 250, 20, shoulderAngle1, shoulderAngle1, 95, '#43B99F',)
                    this.drawAxisline(twoCanvas, 10, 40, shoulderAngle1, 95, '#43B99F')
                }


                let kneeAngle1 = this.getDeepAngle(this.physicalResult.thirdData.left_knee, this.physicalResult.thirdData.right_knee)
                kneeAngle1 = kneeAngle1 - hipAngle1
                if (this.physicalResult.thirdData.right_knee.sz < this.physicalResult.thirdData.left_knee.sz) {
                    this.axisLine(twoCanvas, 150, 80, 250, 80, (360 - kneeAngle1), kneeAngle1, 95, '#00BAFF')
                    this.drawAxisline(twoCanvas, 10, 60, (360 - kneeAngle1), 95, '#00BAFF')
                } else {
                    this.axisLine(twoCanvas, 150, 80, 250, 80, kneeAngle1, kneeAngle1, 95, '#00BAFF')
                    this.drawAxisline(twoCanvas, 10, 60, kneeAngle1, 95, '#00BAFF')
                }
                this.drawBottomTitleText(twoCanvas, "轴位旋转角度", 170, 115)
                this.drawBottomTitleText(twoCanvas, "俯视图", 40, 115)
            } else {
                //没有背面取正面数据
                const hipAngle1 = this.getDeepAngle(this.physicalResult.firstData.left_hip, this.physicalResult.firstData.right_hip)

                if (this.physicalResult.firstData.right_hip.sz < this.physicalResult.firstData.left_hip.sz) {
                    this.axisLine(twoCanvas, 150, 50, 250, 50, (360 - 0), 0, 95, '#2551A2')
                    this.drawAxisline(twoCanvas, 10, 50, (360 - 0), 95, '#2551A2')
                } else {
                    this.axisLine(twoCanvas, 150, 50, 250, 50, 0, 0, 95, '#2551A2')
                    this.drawAxisline(twoCanvas, 10, 50, 0, 95, '#2551A2')
                }

                let shoulderAngle1 = this.getDeepAngle(this.physicalResult.firstData.left_shoulder, this.physicalResult.firstData.right_shoulder)

                shoulderAngle1 = shoulderAngle1 - hipAngle1
                if (this.physicalResult.firstData.right_shoulder.sz < this.physicalResult.firstData.left_shoulder.sz) {
                    this.axisLine(twoCanvas, 150, 20, 250, 20, (360 - shoulderAngle1), shoulderAngle1, 95, '#43B99F')
                    this.drawAxisline(twoCanvas, 10, 40, (360 - shoulderAngle1), 95, '#43B99F')
                } else {
                    this.axisLine(twoCanvas, 150, 20, 250, 20, shoulderAngle1, shoulderAngle1, 95, '#43B99F',)
                    this.drawAxisline(twoCanvas, 10, 40, shoulderAngle1, 95, '#43B99F')
                }


                let kneeAngle1 = this.getDeepAngle(this.physicalResult.firstData.left_knee, this.physicalResult.firstData.right_knee)
                kneeAngle1 = kneeAngle1 - hipAngle1
                console.log("==============",kneeAngle1)
                if (this.physicalResult.firstData.right_knee.sz < this.physicalResult.firstData.left_knee.sz) {
                    this.axisLine(twoCanvas, 150, 80, 250, 80, (360 - kneeAngle1), kneeAngle1, 95, '#00BAFF')
                    this.drawAxisline(twoCanvas, 10, 60, (360 - kneeAngle1), 95, '#00BAFF')
                } else {
                    this.axisLine(twoCanvas, 150, 80, 250, 80, kneeAngle1, kneeAngle1, 95, '#00BAFF')
                    this.drawAxisline(twoCanvas, 10, 60, kneeAngle1, 95, '#00BAFF')
                }
                this.drawBottomTitleText(twoCanvas, "轴位旋转角度", 170, 115)
                this.drawBottomTitleText(twoCanvas, "俯视图", 40, 115)
            }

        },

        //计算角度
        getAngle(firstPoint, midPoint, lastPoint) {

            const vectorA = {
                x: firstPoint.x - midPoint.x,
                y: firstPoint.y - midPoint.y,
            };

            // 向量B从midPoint到lastPoint
            const vectorB = {
                x: lastPoint.x - midPoint.x,
                y: lastPoint.y - midPoint.y,
            };

            // 计算向量A和向量B的点积
            const dotProduct = vectorA.x * vectorB.x + vectorA.y * vectorB.y;

            // 计算向量A和向量B的模
            const magnitudeA = Math.sqrt(vectorA.x * vectorA.x + vectorA.y * vectorA.y);
            const magnitudeB = Math.sqrt(vectorB.x * vectorB.x + vectorB.y * vectorB.y);

            // 防止零向量情况
            if (magnitudeA === 0 || magnitudeB === 0) {
                return 0;
            }

            // 计算余弦值并限制在-1到1之间
            let cosTheta = dotProduct / (magnitudeA * magnitudeB);
            cosTheta = Math.min(Math.max(cosTheta, -1), 1);

            // 计算弧度
            const angleInRadians = Math.acos(cosTheta);

            // 转换为角度
            const angleInDegrees = angleInRadians * (180 / Math.PI);

            return angleInDegrees.toFixed(1);
        },
        getDeepAngle(firstPoint, lastPoint) {
            console.log('firstPoint.sx:' + firstPoint.sx + "  firstPoint.sz:" + firstPoint.sz);
            console.log('lastPoint.sx:' + lastPoint.sx + "  lastPoint.sz:" + lastPoint.sz);
            const vectorLeftToRight = {
                x: lastPoint.sx - firstPoint.sx,
                z: lastPoint.sz - firstPoint.sz
            };

            // 计算该向量与水平 x 轴的夹角
            const angleWithHorizontal = Math.atan2(vectorLeftToRight.z, vectorLeftToRight.x) * (180 / Math.PI);
            console.log('getDeepAngle===' + angleWithHorizontal);
            return angleWithHorizontal
        },
        getcolor(value) {
            console.log('-------------------------' + value);
            if (this.isHospital) {
                return this.colors.normal
            } else {
                if (value && value.includes("正常") || value.includes("阴性")) {
                    return this.colors.normal
                } else {
                    return this.colors.error
                }
            }
        },
    },
}
</script>


<style scoped>
.content-div {
    margin: 13px 30px 0 30px;
    width: auto;
}

.posture-item-bg {
    display: flex;
    margin: 26px 35px 0 35px;
}

.posture-img-bg {
    width: 257px;
    height: 311px;
    background-color: #FFFFFF;
    position: relative;
    border: 1px solid #F0F9F6;
}

.posture-img-bg-multi {
    width: 514px;
    height: 311px;
    background-color: #FFFFFF;
    position: relative;
    border: 1px solid #F0F9F6;
}

.posture-canvas {
    width: 253px;
    height: 311px;
}

.posture-canvas-multi {
    width: 508px;
    height: 311px;
}

.direction-text {
    position: absolute;
    right: 20px;
    top: 30%;
    font-weight: 600;
    font-size: 25px;
    color: black;
    background-color: rgba(255, 255, 255, 0.5);
    border-radius: 3px;
    padding: 1px 10px;
}

/* 文本样式 */
.posture-img-text {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    line-height: 26px;
    margin: 13px 0 0 13px;
    position: absolute;
    left: 0;
    padding: 1px 2px;
    background-color: rgba(255, 255, 255, 0.5);
    border-radius: 3px;

}

/* 图片样式 */
.posture-img-img {
    width: 253px;
    height: 311px;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    /* margin-bottom: 18px; */
}

.posture-prompt-div {
    margin: 26px 35px 0px 35px;
    background-color: #fff;
    width: auto;
    display: flex;
    flex-direction: column;
}

.posture-value-div {
    margin: 9px 35px 0px 35px;
    background-color: #fff;
    width: auto;
    display: flex;
    flex-direction: column;
    border: 1px solid #F0F9F6;
}

.posture-value-title-div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    position: relative;
}

.posture-value-title-div-left {
    display: flex;
    flex-direction: column;
    align-items: start;
}

.posture-value-title-div-left-title {
    display: flex;
    flex-direction: row;
}

.posture-value-title-label-div {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    line-height: 26px;
    text-align: left;
    font-style: normal;
}

.posture-tab-title-div {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 13px;
    color: #333333;
    line-height: 19px;
    align-content: center;
    height: 100%;

}

/* 体态评估概览内容区域 */
.content-tab-div {
    display: flex;
    margin-top: 1px;
}

.content-label-div {
    width: 112px;
    height: 50px;
    display: flex;
    flex-direction: column;
}

.content-label-line-div {
    width: 100%;
    height: 1px;
    background-color: #F0F9F6;
}

.content-label-text-div {
    font-weight: 500;
    font-size: 13px;
    height: 100%;
    color: #333333;
    padding-left: 9px;
    display: flex;
    align-items: center;
    border-top: 1px solid #F0F9F6;
}

.content-value-div {
    width: 147px;
    height: 50px;
    align-items: center;
    justify-content: center;
    display: flex;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 13px;
    color: #333333;
    padding-left: 5px;
    padding-right: 5px;
    flex-direction: column;
    box-sizing: border-box;
    border-top: 1px solid #F0F9F6;
    border-left: 1px solid #F0F9F6;
}

.axis-box {
    display: flex;
    flex-direction: row;
    margin: 26px 35px 0 35px;
}

.axis-box-title {
    font-weight: 500;
    font-size: 19px;
    color: #333333;
    line-height: 26px;
    text-align: left;
    margin-left: 15px;
    margin-top: 13px;
}

.axis-left-box {
    width: 515px;
    height: 175px;
    border: 1px solid #F0F9F6;
    display: flex;
    flex-direction: column;
}

.axis-left-box-content {
    display: flex;
    flex-direction: row;
}

.axis-alert-title {
    font-weight: 400;
    font-size: 13px;
    color: #333333;
    line-height: 19px;
}

.axis-right-box {
    width: 515px;
    height: 175px;
    border-top: 1px solid #F0F9F6;
    border-right: 1px solid #F0F9F6;
    border-bottom: 1px solid #F0F9F6;
}

.code-div {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 30px
}

.code-img {
    margin-left: 35px;
    width: 112px;
    height: 112px;
}

.code-scode-txt {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 13px;
    color: #333333;
    line-height: 19px;
    margin-left: 18px;
}
</style>